import React from "react";

export const FrameWrapperByAnima = (): JSX.Element => {
  // Feature card data with different background colors
  const featureCards = [
    {
      title: "Cultural Art & Crafts",
      description:
        "Traditional Indian art activities and modern crafts that celebrate our rich heritage while developing creativity.",
      iconPath: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-10 w-10">
          <circle cx="13.5" cy="6.5" r=".5" fill="white"></circle>
          <circle cx="17.5" cy="10.5" r=".5" fill="white"></circle>
          <circle cx="8.5" cy="7.5" r=".5" fill="white"></circle>
          <circle cx="6.5" cy="12.5" r=".5" fill="white"></circle>
          <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"></path>
        </svg>
      ),
      bgColor: "bg-[#E53E5F]", // Custom background color for this feature
    },
    {
      title: "Bilingual Learning",
      description:
        "Age-appropriate puzzles and games in both English and Hindi, promoting language skills and cognitive development.",
      iconPath: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-10 w-10">
          <path d="M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.61 1.61a2.404 2.404 0 0 1-1.705.707 2.402 2.402 0 0 1-1.704-.706l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.967-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.402 2.402 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.23 8.77c.24-.24.581-.353.917-.303.515.077.877.528 1.073 1.01a2.5 2.5 0 1 0 3.259-3.259c-.482-.196-.933-.558-1.01-1.073-.05-.336.062-.676.303-.917l1.525-1.525A2.402 2.402 0 0 1 12 1.998c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.967 1.02Z"></path>
        </svg>
      ),
      bgColor: "bg-[#169c97]", // Custom background color for this feature
    },
    {
      title: "Story Adventures",
      description:
        "Interactive storytelling cards featuring Indian mythology and modern tales that spark imagination and cultural pride.",
      iconPath: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-10 w-10">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
        </svg>
      ),
      bgColor: "bg-[#FFC800]", // Custom background color for this feature
    },
    {
      title: "Eco-Friendly Design",
      description:
        "Sustainably sourced materials and recyclable packaging, because we care about the planet's future.",
      iconPath: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-10 w-10">
          <path d="M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5"></path>
          <path d="M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12"></path>
          <path d="m14 16-3 3 3 3"></path>
          <path d="M8.293 13.596 7.196 9.5 3.1 10.598"></path>
          <path d="m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843"></path>
          <path d="m13.378 9.633 4.096 1.098 1.097-4.096"></path>
        </svg>
      ),
      bgColor: "bg-[#267BC7]", // Custom background color for this feature
    },
  ];

  return (
    <section id="features" className="flex flex-col items-start gap-8 md:gap-16 p-4 md:p-16 w-full">
      <div className="flex flex-col items-center gap-6 md:gap-8 w-full">
        <div className="inline-flex items-center border text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-foreground px-4 py-2 rounded-[100px] border-[#169c79] opacity-[0.93]">
          <span className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-extrabold text-[#169c97] text-xs leading-[16.8px]">FEATURES</span>
        </div>
        <div className="flex flex-col items-center justify-center gap-4 w-full">
          <h2 className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-bold text-[#1a1a1a] text-2xl md:text-[40px] leading-tight md:leading-[60px] text-center">
            Crafted for Young Explorers
          </h2>
          <p className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-[#595959] text-sm md:text-base text-center leading-6 w-full">
            Each kit is thoughtfully designed to blend education with entertainment, celebrating Indian culture while keeping little hands busy and minds engaged.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 w-full">
        {featureCards.map(({ title, description, iconPath, bgColor }, index) => (
          <div className="flex flex-col items-start" key={index}>
            <div className="inline-flex items-start pl-6 pr-0 py-0 z-[1]">
              <div className={`inline-flex items-center justify-center p-4 ${bgColor} rounded-lg`}>
                {iconPath}
              </div>
            </div>
            <div className="border bg-card text-card-foreground shadow w-full -mt-7 z-0 border-[#f2edfb] rounded-2xl overflow-hidden min-h-[55px]">
              <div className="p-6 flex flex-col items-start gap-4 pt-[52px] pb-6 px-6">
                <h3 className="self-stretch [font-family:'Plus_Jakarta_Sans',Helvetica] font-semibold text-[#1a1a1a] text-lg md:text-xl leading-[30px]">
                  {title}
                </h3>
                <p className="self-stretch [font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-[#595959] text-sm md:text-base leading-[25.6px]">
                  {description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
